// Per-field layout settings a worksheet reads from the extraction field's description, one
// "key: value" per line (or separated by ";"). Anything else in the description is shown as a hint.
export const WORKSHEET_FIELD_SETTING = {
  SECTION: 'section',
  SHOW_IF: 'showif',
  FORMAT: 'format',
  WIDTH: 'width',
  PREFILL: 'prefill',
  COMPUTE: 'compute',
};

// Where a `prefill:` setting reads a new worksheet's default answer from (compared lowercased).
// Worksheet formulas read only the worksheet's own fields, so loan values reach them through these.
export const WORKSHEET_PREFILL_SOURCE = {
  INVESTOR_CHATTEL_MAX_ADVANCE_PERCENT: 'investor.chattelmaxadvancepercent',
  INVESTOR_NAME: 'investor.name',
  INVESTOR_CHATTEL_RESERVE_PERCENT: 'investor.chattelreservepercent',
  INVESTOR_CHATTEL_SPREAD_PERCENT: 'investor.chattelspreadpercent',
  INVESTOR_CHATTEL_RESERVE_RATE: 'investor.chattelreserverate',
  INVESTOR_CHATTEL_INVESTOR_STATE: 'investor.chattelinvestorstate',
  INVESTOR_CHATTEL_AGREEMENT_DATE: 'investor.chattelagreementdate',
  INVESTOR_CHATTEL_MAX_DELIVERY_AND_SET_PER_SIDE: 'investor.chattelmaxdeliveryandsetperside',
  LOAN_TOTAL_LOAN_AMOUNT: 'loan.totalloanamount',
  LOAN_BASE_LOAN_AMOUNT: 'loan.baseloanamount',
  LOAN_DOWN_PAYMENT: 'loan.downpayment',
  LOAN_INTEREST_RATE: 'loan.interestrate',
  LOAN_TERM_MONTHS: 'loan.termmonths',
  LOAN_MONTHLY_PAYMENT: 'loan.monthlypayment',
  CHATTEL_SALES_PRICE: 'chattel.salesprice',
  CHATTEL_SALES_TAX: 'chattel.salestax',
  CHATTEL_MHIT: 'chattel.mhit',
  CHATTEL_SECTION_COUNT: 'chattel.sectioncount',
  LOAN_INITIAL_ESCROW_DEPOSIT: 'loan.initialescrowdeposit',
  LOAN_MONTHLY_ESCROW: 'loan.monthlyescrow',
  LOAN_PREPAID_FINANCE_CHARGES: 'loan.prepaidfinancecharges',
};

// `prefill: fee: <Fee Name>` reads the amount of the loan's fee(s) of that name, as on the Fees page.
export const WORKSHEET_FEE_PREFILL_SOURCE_PREFIX = 'fee:';

// `prefill: fee: <Name> | <Other Name>` adds up the fees of each name (one charge the fee catalogue
// carries under several names, e.g. the hazard and homeowner's insurance premiums).
export const WORKSHEET_FEE_PREFILL_NAMES_SEPARATOR = '|';

// What a `compute:` setting calculates live from other answers (compared lowercased).
// payment(rate, term, amount): the level monthly payment on amount at an annual rate (%) over term months.
export const WORKSHEET_COMPUTE_FUNCTION = {
  PAYMENT: 'payment',
};

export const WORKSHEET_FIELD_FORMAT = {
  CURRENCY: 'currency',
  PHONE: 'phone',
};

export const WORKSHEET_FIELD_WIDTH = {
  FULL: 'full',
  HALF: 'half',
};

export const WORKSHEET_SETTINGS_SEPARATOR = /\r?\n|;/;

export const WORKSHEET_SHOW_IF_VALUES_SEPARATOR = '|';

export const WORKSHEET_YES = 'Yes';

export const WORKSHEET_NO = 'No';

export const WORKSHEET_DEFAULT_SECTION_KEY = 'worksheet-section-default';
